import React from 'react'
import { usePostRequest } from '../hooks/request'
import { INCOME_TAX_ITEM_LIST } from '../urls'
import IncomeTaxItemForm from './IncomeTaxItemForm'

export default function IncomeTaxItemCreate({ onCancel, onSuccess, finance, incomeTaxId }) {
    const monthCreate = usePostRequest({ url: INCOME_TAX_ITEM_LIST.replace('{incomeTaxId}', finance.id) })

    async function onSubmit(data) {
        const { success } = await monthCreate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <b>Добавить</b><br /><br />
            <IncomeTaxItemForm
                finance={finance}
                incomeTaxId={incomeTaxId}
                onSubmit={onSubmit}
                onCancel={onCancel}
                loading={monthCreate.loading} />
        </div>
    )
}
